var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 12H5C4.11594 12 3.2681 11.6488 2.64298 11.0237C2.01786 10.3985 1.66667 9.5507 1.66667 8.66665C1.66667 7.78259 2.01786 6.93474 2.64298 6.30962C3.2681 5.6845 4.11594 5.33331 5 5.33331H5.59167C6.14167 3.40831 7.91667 1.99998 10 1.99998C11.2156 1.99998 12.3814 2.48287 13.2409 3.34241C14.1004 4.20195 14.5833 5.36774 14.5833 6.58331V6.99998H15.8333C16.4964 6.99998 17.1323 7.26337 17.6011 7.73221C18.0699 8.20105 18.3333 8.83694 18.3333 9.49998C18.3333 10.163 18.0699 10.7989 17.6011 11.2677C17.1323 11.7366 16.4964 12 15.8333 12ZM16.125 5.35831C15.5583 2.49165 13.0333 0.333313 10 0.333313C7.59167 0.333313 5.5 1.69998 4.45833 3.69165C1.95 3.96665 0 6.08331 0 8.66665C0 9.99273 0.526784 11.2645 1.46447 12.2022C2.40215 13.1399 3.67392 13.6666 5 13.6666H15.8333C16.3805 13.6666 16.9223 13.5589 17.4278 13.3495C17.9334 13.1401 18.3927 12.8332 18.7796 12.4463C19.1665 12.0593 19.4734 11.6 19.6828 11.0945C19.8922 10.589 20 10.0472 20 9.49998C20 7.29998 18.2917 5.51665 16.125 5.35831Z",
    fill: "#0D2549"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/storage.d6da7e9c110c3bbf08e05c0fecb0c303.svg";
export { ForwardRef as ReactComponent };